import getEstimatedOneRepMaxExerciseLogSummaryUtil from '../get-estimated-one-rep-max'
import getOneRepMaxExerciseLogSummaryUtil from '../get-one-rep-max'

function getWeightFromRepsAndOneRepMaxExerciseLogSummaryUtil (instance, reps, weight) {
  const oneRepMax = (
    getOneRepMaxExerciseLogSummaryUtil(instance) ||
    getEstimatedOneRepMaxExerciseLogSummaryUtil(instance)
  )

  if (!oneRepMax || reps <= 1) {
    return weight
  }

  // Use re-arranged Epley's formula
  // Weight = 1 Rep Max / (1 + Reps / 30)
  // @see @link {https://en.wikipedia.org/wiki/One-repetition_maximum}
  const newWeight = Math.round(oneRepMax /
    (
      1 +
      (
        reps / 30
      )
    ))

  const diffOfWeight = newWeight - weight
  if (diffOfWeight > 0 && diffOfWeight <= 5) {
    return weight
  }

  return newWeight
}

export { getWeightFromRepsAndOneRepMaxExerciseLogSummaryUtil }
